"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientByHcPartyGenderEducationProfession = void 0;
/*
 * Copyright (c) 2020. Taktik SA, All rights reserved.
 */
const AbstractFilterPatient_1 = require("../../icc-api/model/AbstractFilterPatient");
class PatientByHcPartyGenderEducationProfession extends AbstractFilterPatient_1.AbstractFilterPatient {
    constructor(json) {
        super(json);
        this.$type = 'PatientByHcPartyGenderEducationProfession';
    }
}
exports.PatientByHcPartyGenderEducationProfession = PatientByHcPartyGenderEducationProfession;
//# sourceMappingURL=PatientByHcPartyGenderEducationProfession.js.map